import videojs from "video.js";

// Default options for the plugin.
const defaults = {
  origin: "//easybroadcast.fr",
  logo: "//easybroadcast.fr/img/logo_blue.svg",
};
const registerPlugin = videojs.registerPlugin || videojs.plugin;

const onPlayerReady = (player, options) => {
  const videoJsButtonClass = videojs.getComponent("Button");
  const LogoButtonClass = videojs.extend(videoJsButtonClass, {
    constructor() {
      videoJsButtonClass.call(this, player);
    },
    handleClick() {
      // window.document.location = options.origin;
      const win = window.open(options.origin, "_blank");
      win.focus();
    },
  });

  const logoButton = player.controlBar.addChild(new LogoButtonClass());
  logoButton.addClass("vjs-logo");

  const logoEl = document.getElementsByClassName("vjs-logo")[0];
  logoEl.style.backgroundImage = `url('${options.logo}')`;
  logoEl.style.backgroundRepeat = "no-repeat";
  logoEl.style.backgroundSize = "contain";
  logoEl.style.backgroundPosition = "center";
  logoEl.style.cursor = "pointer";
  logoEl.style.width = "4.8em";
  logoEl.style.height = "90%";
  logoEl.style.marginRight = "5px";
};

/**
 * An EasyBroadcast video.js plugin.
 *
 * logo button
 *
 */
const logoButton = function(options = defaults) {
  this.ready(() => {
    onPlayerReady(this, videojs.mergeOptions(defaults, options));
  });
};

// Register the plugin with video.js.
registerPlugin("logoButton", logoButton);

// Include the version number.
logoButton.VERSION = "1.0";

export default logoButton;



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/ui/videojs-logo-button.js